// components/VerifyEmail/VerifyEmail.jsx (updated)
import React, { useState } from 'react'
import { loadUser, VerifyWithGoogle } from '../../Actions/user'
import { useDispatch, useSelector } from 'react-redux';

const VerifyEmail = ({ email }) => {
  const userState = useSelector((state) => state.user) || {};
  const user = userState.user;
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();

  const VerifyByGoogle = async () => {
    try {
      const data = await VerifyWithGoogle(email);
      if (data?.success) {
        dispatch(loadUser());
      }
      setMessage(data?.message || "Verification attempt finished");
    } catch (error) {
      console.error(error);
      setMessage("Something went wrong. Please try again.");
    }
  }

  // Don't try to read user.isEmailVerified if user is undefined
  if (!user) return null;

  return (
    <div>
      {!user?.isEmailVerified && (
        <div
          onClick={VerifyByGoogle}
          className="flex items-center justify-center gap-2 p-2 mt-3 text-center border-2 border-[#4e67eb] hover:bg-[#4e67eb] hover:text-white rounded-md hover:cursor-pointer"
        >
          <p className="text-sm font-semibold">Verify With Google</p>
        </div>
      )}

      {message && (
        <div className="mt-2 text-sm text-gray-700">
          {message}
        </div>
      )}
    </div>
  )
}

export default VerifyEmail